const styles = theme => ({
  container: {
    margin: -15,
    position: "relative",

    "& button": {
      position: "absolute",
      width: 40,
      height: 40,
      borderRadius: 3,
      backgroundColor: "#000",
      cursor: "pointer",
      top: "50%",
      transform: "translateY(-50%)",
      border: 0,

      "&:focus": {
        outline: "none"
      },

      "&:hover": {
        background: theme.colors.primary,
        color: "black"
      },

      "& svg": {
        fontSize: 24,
        color: "white"
      },

      "&.button-left": {
        left: 15
      },

      "&.button-right": {
        right: 15
      }
    }
  }
});

export default styles;
